
  $(document).ready(function($) {
  "use strict";
  if ($( "#AccessibleNav" ).hasClass('fullwidth_dropdown')) {
	const moveValue = 4;
} else {
  const moveValue = -5;
}
    
    
    $('.menu-item-has-children').mouseover(function(e) {
      var selected = $(this);
      if (selected.children('div.sub-menu-block').hasClass('is-hidden')) {
        selected.addClass('selected').children('div.sub-menu-block').removeClass('is-hidden');
      }
      $('.header__inline-menu').addClass('with-overlay');
      if(window.matchMedia('(min-width: 990px)').matches && !selected.closest('.dt-nav').hasClass('updated-header-height')){
        setHeaderHeightVar();
        selected.closest('.dt-nav').addClass('updated-header-height')
      }
        
      e.preventDefault();
    }).mouseleave(function(e) {
      var selected = $(this);
      selected.removeClass('selected').children('div.sub-menu-block').addClass('is-hidden');
      $('.header__inline-menu').removeClass('with-overlay');
      e.preventDefault();
    });

    function megaMenu() {
      if($("#header .page-full-width").length) {
          var parentRow = $("#header .page-full-width > .row");
          var parentLeft = parseInt(parentRow.css("marginLeft").replace('px', ''));
        } else {
          var parentRow = $("#header .page-width .row");
          var parentLeft = parseInt(parentRow.offset().left);
        }
        var parentWidth = parentRow.width();  
  
        $("#header .page-width .dt-nav li:not(.close-nav)").each(function() {
          var thisItem = $(this);
          if(thisItem.hasClass('has-mega-menu')) {
            var thisItemLeft = thisItem.find('a').offset().left;
            var menuLeft = parseInt(thisItemLeft-parentLeft); 
            // thisItem.find('.sub-menu-block').css('width', parentWidth);  
            // thisItem.find('.sub-menu-block').css('left', -menuLeft);            
          }
        });

    $("sticky-header .dt-nav li:not(.close-nav)").each(function() {
      var thisItem = $(this);
      if(thisItem.hasClass('has-mega-menu')) {
        var thisItemLeft = thisItem.find('a').offset().left;
        var menuLeft = parseInt(thisItemLeft-parentLeft);         

         if ($( "#AccessibleNav").hasClass('fullwidth_dropdown')) { 
      	var menuLeft = menuLeft + 4; 
           var test = "4Full";
          } 
        if ($(".subMenuBlock" ).hasClass('menu-container-width-100')) {          
           var menuLeft = menuLeft + 4; 
           var test = "4Custom";
         }
        
        if ($( "#AccessibleNav").hasClass('default_dropdown')) { 
      	var menuLeft = menuLeft - 5; 
          var test = "5Default";
          } 
        if ($( "#AccessibleNav").hasClass('container_width_dropdown')) { 
      	var menuLeft = menuLeft - 5; 
        var test = "5Container";
          } 
     
        console.log(test);
        // thisItem.find('.sub-menu-block').css('width', parentWidth);
        // thisItem.find('.sub-menu-block').css('left', -menuLeft);
      }      
    });

    window.setTimeout(function(){
      $(window).trigger('resize');
    }, 800);
  }

  var megaMenuResize = false;
  $(window).bind("resize", function() {
    if(!megaMenuResize) {
      megaMenu();
      megaMenuResize = true;
    }
  });
  megaMenu();
   
});


const mediaQuery = window.matchMedia("(min-width: 990px)");


$(document).ready(function(){
  handleTabs(mediaQuery);
  handleLanguagesSwitcher(mediaQuery);
});

$(window).on("resize", function() {
  handleTabs(mediaQuery);
  setHeaderHeightVar();
  handleLanguagesSwitcher(mediaQuery);
});

function handleTabs(e) {
    // REMOVE old handlers first
  $(document).off('click', '.tabs-nav a');
  $(document).off('click', '.mobileTabs .tabs li');

  if (e.matches) {
    // DESKTOP
    $(document).on('click', '.tabs-nav a', function(e) {
      e.preventDefault();

      let id = $(this).attr('href');           
      $('.tabs-nav li').removeClass('active');
      $(this).parent().addClass('active');             
      $(this).closest('.tabs-nav').addClass('active');   

      $('.tabs-content li.dt-sc-menu-tabs').hide();      
      $(this).closest('.tabs-nav').next('.tabs-content').find(id).show();
    });

  } else {
    // MOBILE
    $(document).on('click', '.mobileTabs .tabs li', function() {
      $(this).toggleClass('active');
      $(this).next('div').slideToggle(0);
      $(this).next('div').children('.dt-sc-menu-tabs').show();
    });
  }
}

function handleLanguagesSwitcher(e){
  const desktopSwitcher = $('.header__left.language-currency-switcher .languages-switcher');
  const mobileSwitcher = $('.menu-drawer__utility-links.language-currency-switcher .languages-switcher');
  if (e.matches) {
    if(!desktopSwitcher.length && mobileSwitcher.length){
      $('.header__left.language-currency-switcher').append(mobileSwitcher);
    } 
  }else{
    if(desktopSwitcher.length){
      $('.menu-drawer__utility-links.language-currency-switcher').append(desktopSwitcher);
    }
  }
}

$(window).on('load', function() {
  setHeaderHeightVar();
  myFunction();
});

function setHeaderHeightVar() {
  const header = document.getElementById("Top_Header");
  if (!header) return;

  const height = header.offsetHeight;
  document.documentElement.style.setProperty('--header-height', height + 'px');
}


window.onscroll = function() {myFunction()};

var header = document.getElementById("Top_Header");
//var sticky = header.offsetTop;
var sticky = 25;

function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}
